import Repository from "./Repository";

const resource = "/groups";

export default {
    get(){
        return Repository.get(`${resource}/`);
    },
}